export default Object.freeze({
  PREDICT: 'PREDICT',
  TRAIN: 'TRAIN',
  TRAIN_AND_PREDICT: 'TRAIN_AND_PREDICT',
});
